export const profilDTO = {
  telephone: '',
  telephone2: '',
  email: '',
  ville: '',
  adresse: '',
  imageUrl: '',
  nom: '',
  prenom: '',
  id: '',
  cin: [],
};

export const initProfilDTO = {
  telephone: false,
  email: false,
  ville: false,
  adresse: false,
  image: false,
};

export const sexes = [
  {label: 'Choisir', value: ''},
  {label: 'Homme', value: 'M'},
  {label: 'Femme', value: 'F'},
];
